import { useFormatMessage } from '../../helpers/intl'

export const useTransactionSearchTranslation = () => {
  const startMethodText = useFormatMessage('dashboard.transactionsPage.advancedSearch.startMethod', 'Start Method')
  const stateText = useFormatMessage('dashboard.transactionsPage.advancedSearch.state', 'State')
  const transactionIDText = useFormatMessage('dashboard.selector.transactionID', 'Transaction ID')
  const tranasctionStateText = useFormatMessage('dashboard.text.transactionState.heading', 'Transaction State')
  const paymentStateText = useFormatMessage('dashboard.transactionsPage.advancedSearch.paymentState', 'Payment State')
  const rfidNumberText = useFormatMessage('dashboard.transactionsPage.rfid', 'RFID Number')
  const rfidNicknameText = useFormatMessage('dashboard.transactionsPage.rfidNickname', 'RFID Nickname')
  return { startMethodText, stateText, transactionIDText, tranasctionStateText, paymentStateText, rfidNumberText, rfidNicknameText }
}
